import React, { useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import * as ProductionOrderSapServices from "../../../../services/ProductionOrderSapService";
import {
  ContainerData,
  LabelData,
  ButtonAction,
  ContainerProdCons,
  TitleProdCons,
  Icon,
  HeadTable,
  RowTable,
} from "./productionOrderSapDetail.styled";
import Breadcrumb from "../../../utils/breadCrumbs";
import { getDateFormatTimeZone } from "../../../../utils/formats";
import {
  POSAP_STATUS,
  POSAP_STATUS_PENDING,
  POSAP_STATUS_READY_TO_SEND,
} from "../../../../constants";
import { useProductionOrderSapExtraInfo } from "../hook/useProductionOrderSapExtraInfo";
import Detail from "./productionOrderSapDetail.view";

const ProductionOrderSapDetailContainer = ({ uuid }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [forceRefresh, setForceRefresh] = useState(false);

  const refresh = () => {
    setForceRefresh(true);
  };

  const { addExtraInfo } = useProductionOrderSapExtraInfo(refresh);

  useEffect(() => {
    if (forceRefresh) {
      ProductionOrderSapServices.getDetail(uuid).then((order) => {
        setData(order);
      });
      setForceRefresh(false);
    }
  }, [forceRefresh, uuid]);

  useEffect(() => {
    ProductionOrderSapServices.getDetail(uuid).then((order) => {
      setData(order);
    });
  }, [uuid]);

  const goBack = async () => {
    navigate(PATHS.PRODUCTION_ORDER_SAP_LIST);
  };

  const handlerOnExtraInfo = async () => {
    try {
      await addExtraInfo(undefined, data);
    } catch (error) {}
  };

  return (
    <Detail
      goBack={goBack}
      handlerOnExtraInfo={handlerOnExtraInfo}
      orderData={data}
      refresh={refresh}
    ></Detail>
  );
};

ProductionOrderSapDetailContainer.propTypes = {};

export default ProductionOrderSapDetailContainer;
